/**
 * Scoped CSS that neutralises the built-in card background of the mounted
 * analytics chart components (heat_map, area_control, shot_map, top_players)
 * so the Panel wrapper owns the background. Scoped to the wrapper attribute;
 * no guarded file is edited. `unset` panel = no override (legacy look).
 */
export const PANEL_OVERRIDE_ATTR = "data-bcast-panel-override";

export function chartPanelOverrideCss(): string {
  const s = `[${PANEL_OVERRIDE_ATTR}="true"]`;
  return [
    `${s} [data-testid="analytics-panel"] > :nth-child(2){background:transparent !important;background-image:none !important;box-shadow:none !important;border-color:transparent !important}`,
    `${s} [data-testid="analytics-panel"]{background:transparent !important;background-image:none !important}`,
    `${s} [data-testid="top-players-section"],${s} [data-testid="analytics-goal-mouth-section"]{background:transparent !important;background-image:none !important;box-shadow:none !important}`,
    `${s} [class*="bg-slate-"],${s} [class*="bg-emerald-"],${s} [class*="bg-gradient"]{background-color:transparent !important;background-image:none !important}`,
  ].join("\n");
}

/** Wrapper that opts a mounted chart widget into the override. */
export const overrideProps = (active: boolean) =>
  active ? ({ [PANEL_OVERRIDE_ATTR]: "true" } as Record<string, string>) : {};
